import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=b6da6dba&scoped=true"
import script from "./Train.vue?vue&type=script&lang=js"
export * from "./Train.vue?vue&type=script&lang=js"
import style0 from "./Train.vue?vue&type=style&index=0&id=b6da6dba&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6da6dba",
  null
  
)

export default component.exports